
class MyOffersController {
    constructor(competitionService, breakpointsService) {
        this.$onInit = function() {
            this.hasOffers = false;
            this.competitionService = competitionService;
            this.competitions = null;
            this.breakpointsService = breakpointsService;
        };
    }


    getCompDetails(comps) {
        this.competitionService.getAllCompetitionDetails(comps).then(res => {
            if (res.Competition.length > 0) {
                this.hasOffers = true;

                this.competitions = res.Competition;
                angular.forEach(this.competitions, competition => {
                    const url = competition.Image;
                    const path = url.split('/').slice(0, -1).join('/') + '/';
                    const name = url.split('/').slice(-1).join().split('.').shift();
                    const ext = url.split('.').pop();

                    const size = this.breakpointsService.isSmallFormat() ? '-small' : '-thumbnail';

                    competition.Image = path + name + size + '.' + ext;
                });
            } else {
                this.hasOffers = false;
            }
        });
    }

}

module.exports = function () {
    return {
        restrict: 'E',
        controller: ['CompetitionService', 'BreakpointsService', MyOffersController],
        controllerAs: 'ctrl',
        bindToController: {
        },
        scope: {
            order: '=',
            compIds: '='
        },
        link(scope) {

            scope.loading = false;
            scope.buttonText = 'Enter now ';

            scope.userDetails = {
                FreeText: null
            };

            scope.submitComp = function (form, competition, $index) {
                if (form.$invalid) {
                    return false;
                }

                scope.loading = true;
                scope.ctrl.competitions[$index].loading = true;
                scope.ctrl.competitions[$index].buttonText = 'submitting ';

                const compDetails = {
                    CompetitionUrlCode: competition.UrlCode,
                    OrderId: scope.order.OrderId,
                    ShareCustomerDetails: competition.shareCustomerDetails !== undefined,
                    FreeText: scope.userDetails.FreeText
                };

                scope.ctrl.competitionService.enterCompetitionByOrderId(compDetails).then(res => {
                    scope.ctrl.competitions[$index].loading = false;
                    scope.ctrl.competitions[$index].HideForm = true;

                    if (res.Success) {
                        scope.ctrl.competitions[$index].confirmationMessage = 'Good luck and thanks for entering!';

                    } else {
                        if (res.FieldErrors.UniqueCode[0].length) {
                            scope.ctrl.competitions[$index].error = 'Sorry looks as though you have already entered this competition';
                        }
                    }

                });

            };

            scope.$watch('compIds', function (newValue, oldValue) {

                if (newValue !== oldValue) {
                    if (newValue.length) {
                        scope.ctrl.getCompDetails(newValue);
                    }
                }
            });
        },
        template: require('./my-offers-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/my-offers-directive.js
 **/